var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "app-header" }, [
      _c("div", { staticClass: "bread-crumb" }, [
        _c(
          "ul",
          { staticClass: "list-item-container" },
          _vm._l(_vm.arrayStep, function(item, index) {
            return _c("li", { key: item, staticClass: "list-item" }, [
              _c(
                "a",
                {
                  staticClass:
                    "step-name-breadcrumb body-text scheduler-text-custom-color",
                  style: {
                    "font-weight":
                      item === "Select services" ? "bold" : "normal"
                  },
                  attrs: { href: "javascript:void(0)" }
                },
                [_vm._v("\n            " + _vm._s(item) + "\n          ")]
              ),
              _vm._v(" "),
              index != _vm.arrayStep.length - 1
                ? _c("div", {
                    staticClass: "arrow-icon",
                    attrs: { role: "navigation" }
                  })
                : _vm._e()
            ])
          })
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "my-information-container" }, [
      _c(
        "h1",
        {
          ref: "focusTab",
          staticClass: "h1-text step-name",
          attrs: { tabindex: "0" }
        },
        [_vm._v("Select Services")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "body-text margin-top-10px" }, [
        _vm._v(
          "Welcome to the ADURO WellMetrics scheduling tool. Before you begin to schedule, we need to know some information about you. Your selections will determine which events are available for you. You can edit this information later."
        )
      ]),
      _vm._v(" "),
      _vm.hasFluShot
        ? _c(
            "div",
            {
              staticClass:
                "my-info-card common-card margin-top-24px scheduler-card-responsive"
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "check-box-responsive margin-top-24px" },
                [
                  _c(
                    "div",
                    { staticClass: "checkbox-container" },
                    [
                      _c(
                        "b-checkbox",
                        {
                          staticClass:
                            "ap-checkbox-group body-text scheduler-checkbox-group-custom",
                          style: {
                            "font-weight": _vm.screenBoxStatus
                              ? "bold"
                              : "normal"
                          },
                          attrs: { id: "checkbox-1" },
                          model: {
                            value: _vm.screenBoxStatus,
                            callback: function($$v) {
                              _vm.screenBoxStatus = $$v
                            },
                            expression: "screenBoxStatus"
                          }
                        },
                        [
                          _vm._v(
                            "\n            I want to get a biometric screening\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "check-box-responsive margin-top-16px" },
                [
                  _c(
                    "div",
                    { staticClass: "checkbox-container" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass:
                            "ap-checkbox-group body-text scheduler-checkbox-group-custom",
                          style: {
                            "font-weight": _vm.fluBoxStatus ? "bold" : "normal"
                          },
                          attrs: { id: "checkbox-2" },
                          model: {
                            value: _vm.fluBoxStatus,
                            callback: function($$v) {
                              _vm.fluBoxStatus = $$v
                            },
                            expression: "fluBoxStatus"
                          }
                        },
                        [
                          _vm._v(
                            "\n            I want to get a flu shot\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasSpousal
        ? _c(
            "div",
            {
              staticClass:
                "my-info-card common-card margin-top-24px scheduler-card-responsive"
            },
            [
              _c("div", { staticClass: "card-header-container" }, [
                _c("h2", { staticClass: "h5-text", attrs: { tabindex: "0" } }, [
                  _vm._v(_vm._s(_vm.spouseLabel) + " Information")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "body-text margin-top-10px" }, [
                _vm._v(
                  "\n        If you have a " +
                    _vm._s(_vm.spouseLabel) +
                    ", you can also schedule appointments for them. If your " +
                    _vm._s(_vm.spouseLabel) +
                    " is also an employee at your company, please have them schedule their own appointment or come with you as a walk-in appointment (additional wait time may apply).\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "check-box-responsive margin-top-24px" },
                [
                  _c(
                    "div",
                    { staticClass: "checkbox-container" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass:
                            "ap-checkbox-group body-text scheduler-checkbox-group-custom",
                          style: {
                            "font-weight":
                              _vm.spousalBoxStatus === "accepted"
                                ? "bold"
                                : "normal"
                          },
                          attrs: { id: "checkbox-3" },
                          model: {
                            value: _vm.spousalBoxStatus,
                            callback: function($$v) {
                              _vm.spousalBoxStatus = $$v
                            },
                            expression: "spousalBoxStatus"
                          }
                        },
                        [
                          _vm._v(
                            "\n            I will be bringing my " +
                              _vm._s(_vm.spouseLabel) +
                              " to this event\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _vm.spousalBoxStatus
                ? _c("div", { staticClass: "set-height-including-calendar" }, [
                    _c("div", { staticClass: "text-box-responsive" }, [
                      _c("div", { staticClass: "row name-input-wrapper" }, [
                        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "field-display-wrapper margin-top-16px"
                            },
                            [
                              _c("div", { staticClass: "field-wrapper" }, [
                                _c(
                                  "div",
                                  { attrs: { id: "firstNameElement" } },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "ap-checkbox-group scheduler-checkbox-group-custom margin-top-16px",
                                        attrs: { for: "inputFirstName" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      First Name\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      ref: "firstName",
                                      staticClass: "input",
                                      attrs: {
                                        id: "inputFirstName",
                                        role: "textbox",
                                        type: "text",
                                        name: "firstName",
                                        placeholder: "First name",
                                        disabled: ""
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "require-field-icon",
                                    attrs: {
                                      "aria-label":
                                        "* field denotes as Mandatory fields."
                                    }
                                  },
                                  [_vm._v("*")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "error-display",
                                  class: {
                                    noDisplay:
                                      _vm.spousalBoxStatus === "not_accepted"
                                  },
                                  attrs: { id: "firstNameError" }
                                },
                                [
                                  _vm.errors.has("firstName")
                                    ? _c("div", {
                                        staticClass: "alert-icon-red-error",
                                        attrs: { "aria-label": "Error icon" }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "error-text-color" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("firstName"))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "field-display-wrapper margin-top-16px"
                            },
                            [
                              _c("div", { staticClass: "field-wrapper" }, [
                                _c(
                                  "div",
                                  { attrs: { id: "lastNameElement" } },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "ap-checkbox-group scheduler-checkbox-group-custom margin-top-16px",
                                        attrs: { for: "inputLastName" }
                                      },
                                      [_vm._v("Last Name")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      ref: "lastName",
                                      staticClass: "input",
                                      attrs: {
                                        id: "inputLastName",
                                        role: "textbox",
                                        type: "text",
                                        name: "lastName",
                                        placeholder: "Last name",
                                        disabled: ""
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "require-field-icon",
                                    attrs: {
                                      "aria-label":
                                        "* field denotes as Mandatory fields."
                                    }
                                  },
                                  [_vm._v("*")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "error-display",
                                  class: {
                                    noDisplay:
                                      _vm.spousalBoxStatus === "not_accepted"
                                  },
                                  attrs: { id: "lastNameError" }
                                },
                                [
                                  _vm.errors.has("lastName")
                                    ? _c("div", {
                                        staticClass: "alert-icon-red-error",
                                        attrs: { "aria-label": "Error icon" }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "error-text-color" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("lastName"))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6 col-xs-12" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "email-input-wrapper field-display-wrapper"
                            },
                            [
                              _c("div", { staticClass: "field-wrapper" }, [
                                _c("div", { attrs: { id: "emailElement" } }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "ap-checkbox-group scheduler-checkbox-group-custom margin-top-16px",
                                      attrs: { for: "inputSpouseEmail" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Email\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    ref: "email",
                                    staticClass: "input",
                                    attrs: {
                                      id: "inputSpouseEmail",
                                      role: "textbox",
                                      type: "email",
                                      name: "email",
                                      placeholder: "Email",
                                      disabled: ""
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "require-field-icon",
                                    attrs: {
                                      "aria-label":
                                        "* field denotes as Mandatory fields."
                                    }
                                  },
                                  [_vm._v("*")]
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6 col-xs-12" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-6 col-xs-6" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "birthday-input-wrapper field-display-wrapper"
                                },
                                [
                                  _c("div", { staticClass: "field-wrapper" }, [
                                    _c(
                                      "div",
                                      {
                                        ref: "dob1",
                                        attrs: { id: "dobElement" }
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "ap-checkbox-group scheduler-checkbox-group-custom margin-top-16px",
                                            staticStyle: {
                                              "min-width": "228px"
                                            },
                                            attrs: {
                                              "aria-label":
                                                "Enter Spouce Birth Date using format MM/DD/YYYY"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                          Spouse Birth Date\n                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          ref: "dob",
                                          staticClass: "input",
                                          attrs: {
                                            id: "picker-component-container",
                                            role: "textbox",
                                            name: "dob",
                                            placeholder: "Birth date",
                                            disabled: ""
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "require-field-icon",
                                        attrs: {
                                          "aria-label":
                                            "* field denotes as Mandatory fields."
                                        }
                                      },
                                      [_vm._v("*")]
                                    )
                                  ])
                                ]
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(1)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header-container" }, [
      _c(
        "h2",
        {
          staticClass: "h5-text",
          attrs: {
            "aria-label":
              "Event Information please select at least one of the follwoing options to continue",
            role: "Heading",
            tabindex: "0"
          }
        },
        [_vm._v("Event Information")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "body-text card-sub-title" }, [
        _vm._v("Select all that apply, please select at least one option."),
        _c(
          "span",
          {
            staticClass: "require-field-icon",
            staticStyle: { color: "red", "padding-left": "5px" }
          },
          [_vm._v("*")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "select-button-container margin-top-24px" },
      [
        _c(
          "button",
          {
            staticClass:
              "select-button ap-btn scheduler-button-custom-color button-text-white",
            attrs: { "aria-label": "Select location", role: "button" }
          },
          [_vm._v("\n        SELECT LOCATION\n      ")]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d2209c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d2209c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/preview/SchedulerPreviewMyInfoPage.vue
// module id = 1638
// module chunks = 1